
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';

export class AssignedParentSubjectSelectionForm extends Form {
	private static _instance = new AssignedParentSubjectSelectionForm();
	offeredSubjectId:Field = {
		name:'offeredSubjectId'
		,controlType: 'Hidden'
		,label: 'Select a Subject'
		,isRequired: true
		,listName: 'staffSubjectList'
		,valueType: 1
		,errorId: 'invalidId'
		,maxValue: 9999999999999
	};

	public static getInstance(): AssignedParentSubjectSelectionForm {
		return AssignedParentSubjectSelectionForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();
		this.controls.set('offeredSubjectId', [Validators.required, Validators.max(9999999999999)]);
		this.fields.set('offeredSubjectId', this.offeredSubjectId);
		this.listFields = ['offeredSubjectId'];
	}

	public getName(): string {
		 return 'assignedParentSubjectSelection';
	}
}


export class AssignedParentSubjectSelectionFd extends FormData {
	constructor(form: AssignedParentSubjectSelectionForm, sa: ServiceAgent) {
		super(form, sa);
	}

	setFieldValue(name: 'offeredSubjectId', value: string | number | boolean | null ): void {
		super.setFieldValue(name, value);
	}

	getFieldValue(name: 'offeredSubjectId' ): string | number | boolean | null {
		return super.getFieldValue(name);
	}
}


export interface AssignedParentSubjectSelectionVo extends Vo {
	offeredSubjectId?: number
}
